export default __webpack_public_path__ + "0682e8e1697112b5ed257f4e1ba48c66.png";